/**
 * chartFilters.js - the per-chart date window (this quarter, last 12 months,
 * custom range...) and the open/won/lost/cancelled split every chart starts from.
 */

import { isCancelledStatus } from '../../data/projectStatus';

/* ===== CHART FILTER HELPERS ===== */
export const FILTER_OPTIONS = [
  { value: '1w', label: 'Last 1 Week' },
  { value: '2w', label: 'Last 2 Weeks' },
  { value: '1m', label: 'Last 1 Month' },
  { value: '3m', label: 'Last 3 Months' },
  { value: '6m', label: 'Last 6 Months' },
  { value: 'year', label: 'This Year' },
  { value: 'lastyear', label: 'Last Year' },
  { value: 'byyear', label: 'By Year (2021–present)' },
  { value: '2y', label: 'Last 2 Years (Monthly)' },
  { value: '3y', label: 'Last 3 Years (Monthly)' },
  { value: 'custom', label: 'Custom Range' },
];

export function getFilterRange(value) {
  const now = new Date();
  const iso = (d) => d.toISOString().slice(0, 10);
  const y = now.getFullYear(),
    m = now.getMonth(),
    d = now.getDate();
  switch (value) {
    case '1w':
      return { from: iso(new Date(y, m, d - 7)), to: iso(now) };
    case '2w':
      return { from: iso(new Date(y, m, d - 14)), to: iso(now) };
    case '1m':
      return { from: iso(new Date(y, m - 1, d)), to: iso(now) };
    case '3m':
      return { from: iso(new Date(y, m - 3, d)), to: iso(now) };
    case '6m':
      return { from: iso(new Date(y, m - 6, d)), to: iso(now) };
    case 'year':
      return { from: `${y}-01-01`, to: iso(now) };
    case 'lastyear':
      return { from: `${y - 1}-01-01`, to: `${y - 1}-12-31` };
    case 'byyear':
      return { from: '2021-01-01', to: iso(now) };
    case '2y':
      return { from: iso(new Date(y - 2, m, d)), to: iso(now) };
    case '3y':
      return { from: iso(new Date(y - 3, m, d)), to: iso(now) };
    default:
      return { from: '', to: '' };
  }
}

export function filterByDate(arr, filterValue, customFrom, customTo) {
  if (!filterValue || filterValue === 'byyear') return arr;
  const range = filterValue === 'custom' ? { from: customFrom || '', to: customTo || '' } : getFilterRange(filterValue);
  if (!range.from && !range.to) return arr;
  return arr.filter((p) => {
    const d = p.quoteDate || p.quote_date || '';
    if (!d) return false;
    if (range.from && d < range.from) return false;
    if (range.to && d > range.to) return false;
    return true;
  });
}

export function getFilteredSets(projects) {
  const won = projects.filter((p) => (p.status || '').toLowerCase() === 'won');
  const lost = projects.filter((p) => (p.status || '').toLowerCase() === 'lost');
  const open = projects.filter((p) => (p.status || '').toLowerCase() === 'open');
  const cancelled = projects.filter((p) => isCancelledStatus(p.status)); // Q-01: Cancelled (was Dead)
  // The live pipeline. It used to be Open + Budget; Budget was folded into
  // Open on 9/29/26, so it is the open list now. The name stays for its callers.
  const activeBids = open;
  return { won, lost, open, cancelled, activeBids };
}
